import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { action, computed, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { IUsuario } from '../modelo';
import EscaninhoStore from '../store/EscaninhoStore';
import GabineteStore from '../store/GabineteStore';

interface IPropsSelectServidores {
    handleChangeServidorDropDown: (event) => any;
    servidorAtribuido:string;
    callbackServidorAtribuido?: (servidorAtribuido:string) => any;
    movimentacaoIncompleta: boolean;
    lote?: boolean;
    naoMostrarOpcaoManterResponsavel?:boolean;
}

class SelectServidores extends React.Component<IPropsSelectServidores> {
    constructor(props: IPropsSelectServidores) {
        super(props);

        makeObservable(this, {
            listaServidores: computed,
            handleChangeServidorDropDown: action,
            qtdProcessosSelecionados: computed
        });
    }

    get listaServidores() {
        return GabineteStore.listaUsuariosOrdenadoGabinete || [];
    }

    get servidoresMenuItem() {

        const servidores = [];

        this.listaServidores.forEach((servidor, index) => {
            const estiloMagistrado = servidor.magistrado ? { fontWeight: 'bold' } : undefined;
            servidores.push(
                <MenuItem
                    value={servidor.login}
                    key={index}
                    style={estiloMagistrado}
                >
                    {servidor.nome}
                </MenuItem>
                );
        });

        servidores.unshift(this.servidoresSelecione);    

        if (this.props.lote && !this.props.naoMostrarOpcaoManterResponsavel) {
            servidores.unshift(this.servidoresSelecioneLote);
        }

        return servidores;
    }


    isMinistro(servidor: IUsuario) {
        return servidor.localizacoes.every(l => l.papel.identificador === 'magistrado');
    }

    servidoresSelecione = [
        <MenuItem value={-1} key={'menu-item-sem-responsavel'}>
            Sem Responsável
        </MenuItem>,
    ];

    readonly servidoresSelecioneLote = [
        <MenuItem value={-2} key={'menu-item-sem-responsavel-lote'}>
            Manter responsável atual do processo
        </MenuItem>,
    ];

    handleChangeServidorDropDown = (event) => {
        this.props.handleChangeServidorDropDown(event);
    };

    get qtdProcessosSelecionados(): number {
        return EscaninhoStore.processosSelecionados.length;
    }

    render() {
        return (
            <FormControl fullWidth >
                <InputLabel id="label-responsavel">Responsável {this.props.movimentacaoIncompleta ? '*' : ''}</InputLabel>
                {this.qtdProcessosSelecionados > 1 ? (
                    <Select
                        labelId='label-responsavel'
                        label='Modifique o responsável do processo'
                        id={'dropDownMenuServidores'}
                        value={this.props.servidorAtribuido}
                        onChange={this.handleChangeServidorDropDown}
                        style={{ width: '95%' }}
                    >
                        {this.servidoresMenuItem}
                    </Select>) : (
                    <Select
                        labelId='label-responsavel'
                        label='Modifique o responsável do processo'
                        id={'dropDownMenuServidores'}
                        value={this.props.servidorAtribuido}
                        onChange={this.handleChangeServidorDropDown}
                        style={{ width: '95%' }}
                    >
                        {this.servidoresMenuItem}
                    </Select>
                )}
            </FormControl>
        );
    }
}

export default observer(SelectServidores);
